import React from 'react';
import { Link } from 'react-router-dom';

function QuickStart() {
  return (
    <div className="docs-content">
      <h1>Quick Start</h1>
      <p className="docs-lead">
        Get up and running with SignTada in minutes. This guide walks you through account setup, your first document request, and where to find API credentials.
      </p>

      <h2>1. Create or join an account</h2>
      <p>
        If you are the first user in your organization, <strong>register</strong> with your email and password (or sign in with Google). You will be assigned the <strong>Super Admin</strong> role and can create companies, invite users, and manage branding. If someone else has already set up SignTada, ask an Admin or Super Admin to invite you; you will receive an email to complete registration.
      </p>

      <h2>2. Open the dashboard</h2>
      <p>
        After logging in, you land on the main <strong>Dashboard</strong>. Here you see high-level stats (total documents, signed, pending, completion rate), recent activity, top recipients, and quick actions. Use the sidebar to navigate to <strong>Documents</strong>, <strong>New Request</strong>, <strong>Templates</strong>, and <strong>Webhooks</strong> (if your role allows).
      </p>

      <h2>3. Send your first document</h2>
      <p>
        Go to <strong>New Request</strong> in the sidebar. Upload a PDF (or choose a template if you have one), add one or more recipients with their email addresses, and place signature and optional text fields on the document. You can enable email notifications, OTP verification, and set an expiry date. Click <strong>Send</strong>; recipients receive a link to view and sign the document.
      </p>

      <h2>4. Track and download</h2>
      <p>
        In <strong>Documents</strong>, filter by status (All, Signed, Pending, Rejected) and open any request to see recipient-level signing status. When all required signatures are collected, download the signed PDF and the <strong>audit trail</strong> for your records. Webhooks can notify your system when documents are signed or rejected.
      </p>

      <h2>5. Use the API (optional)</h2>
      <p>
        For integrations and automation, get your <strong>API key</strong> from <strong>Settings</strong> in the dashboard. All API requests use the base URL <code>https://api.signtada.com</code>. Send the key in the <code>X-API-Key</code> header for protected endpoints. See the <Link to="/api-keys">API Keys</Link> guide and the <Link to="/api-reference">API Reference</Link> for full details.
      </p>

      <h2>Next steps</h2>
      <ul>
        <li><Link to="/user-roles">User Roles</Link> — Understand USER, ADMIN, and SUPER_ADMIN permissions.</li>
        <li><Link to="/dashboard">Dashboard Guide</Link> — Explore every section of the dashboard.</li>
        <li><Link to="/signing-flow">Signing Flow</Link> — How senders and recipients interact end to end.</li>
      </ul>
    </div>
  );
}

export default QuickStart;
